import React from "react";
import './Stockholder.css'
import stackholderImage from '../../utils/assets/images/stackholder-bg.png'
import stackholderResponsiveImage from '../../utils/assets/images/stackholder-res.png'
const Stockholder = () => {
    return(
        <>
        <div className="stackholder-wrapper" id="stakeholders">
            <div className="stackholder-wrapper-title">
                <div></div>
                <div>Stakeholders</div>
                
            </div>
            <div className="ctr stakholder-content-wrapper">
                    <div className="stakholder-content">
                        <h1>Upstream </h1>
                        <p> Renewable Power & Interconnection</p>
                    </div>
                    
                </div>
                <div className="ctr stakholder-image-container">
                <img  className="stackholder-image" src={stackholderImage}/>
                <img className="responsive-stackholder-image" src={stackholderResponsiveImage}/>
                </div>
            

        </div>
        </>
    )
}
export default Stockholder